import { Membership } from "types";
import { getMembershipItemDisabledReasons } from "@/components/PurchaseCreate/hooks/getMembershipValidations";
import { isMembershipItem } from "@/models/PurchaseItem";
import { getItemProduct, useCreatePurchaseStore } from "@/stores/createPurchaseStore";

/** Returns the validation errors for any of the items on "Checkout" page. Only applicable for multi step checkout. */
export const getMistCheckoutValidations = () => {
    const { isOneStepCheckout, purchase } = useCreatePurchaseStore.getState();

    const getDisabledReasons = () => {
        const messages: string[] = [];

        if (!isOneStepCheckout) {
            for (const item of purchase.items) {
                if (!isMembershipItem(item)) continue;

                const purchaseItemDisabledReasons = getMembershipItemDisabledReasons(item);
                const membership = getItemProduct<Membership>(item);
                messages.push(...purchaseItemDisabledReasons.map((message) => `${membership.name}: ${message}`));
            }
        }

        return messages;
    };

    return { getDisabledReasons };
};
